import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';

import { COLOR_L5_SLATE_NIGHT } from '../libs/consts';

import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import EnterprisePage from 'js/src/components/public-pages/EnterprisePage';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { renderComponent } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const EnterprisePageContainer = React.memo(function EnterprisePageContainer() {
    return (
        <PublicPagesTrim
            headerBackgroundColor={COLOR_L5_SLATE_NIGHT}
            invertHeaderContentColor={true}
        >
            <EnterprisePage />
        </PublicPagesTrim>
    );
});

renderComponent(EnterprisePageContainer);
